import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div id='PrivacyPolicy' className="container py-5" style={{marginTop: '7rem'}}>
      <div className="mb-4" data-aos="fade-up">
        <h1 className="display-5 fw-bold">Privacy Policy</h1>
        <h2 className="h5 fw-semibold">Rayan Info Solutions</h2>
        <p className="text-muted">Effective Date: April 1, 2024</p>
      </div>

      <p className="mb-4" data-aos="fade-up">
        At Rayan Info Solutions, we are committed to safeguarding your personal information and respecting your digital privacy.
        This Privacy Policy outlines how we gather, handle, and protect your data when you interact with our websites, software, and services.
        By continuing to use our platforms, you agree to the practices described herein.
      </p>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">1. Data We May Collect</h3>
        <p>
          Depending on how you interact with us, we may collect identifiable information such as your name, email address, phone number,
          and payment-related data. This information is typically provided voluntarily by you through forms, chats, or sign-up procedures.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">2. How We Acquire Information</h3>
        <p>
          We collect data directly when you create an account, use our services, or reach out to us. We also gather limited technical information
          using cookies or similar technologies to improve your user experience and service quality.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">3. Usage of Your Data</h3>
        <p>
          Your personal details are utilized to operate, personalize, and enhance our services. We may use your data to process transactions,
          send service-related alerts, and respond to support queries. Aggregated, anonymized data may be used internally for performance
          optimization and strategy analysis.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">4. Data Security Practices</h3>
        <p>
          We implement industry-standard security protocols to help protect your information from unauthorized access or misuse. While
          we strive for the highest level of protection, no system can be fully immune to risk, and we advise users to take precautionary
          measures on their end as well.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">5. Sharing of Information</h3>
        <p>
          Rayan Info Solutions does not engage in selling or leasing your personal data to third parties. However, we may collaborate with
          verified service partners to facilitate certain operations. These third parties are contractually obligated to adhere to strict
          data privacy standards.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">6. Your Rights & Choices</h3>
        <p>
          You may request access, modification, or removal of your stored information by contacting us. Additionally, users have the option to
          unsubscribe from promotional communications at any time through the provided opt-out links or by writing to us directly.
        </p>
      </div>

      <div className="mb-4" data-aos="fade-up">
        <h3 className="h6 fw-bold">7. Policy Revisions</h3>
        <p>
          We may revise this Privacy Policy periodically to reflect changes in our practices or legal requirements. Any substantial updates
          will be posted here, and your continued use of our services will signify acceptance of those updates.
        </p>
      </div>

      <div className="mb-5" data-aos="fade-up">
        <h3 className="h6 fw-bold">8. Contacting Us</h3>
        <p>
          If you have any questions, concerns, or feedback regarding your data or this Privacy Policy, we encourage you to connect with us
          directly at <a href="mailto:rayaninfosolutions@gmail.com">rayaninfosolutions@gmail.com</a>.
        </p>
      </div>

      <div className="pt-3 border-top" data-aos="fade-up">
        <p className="mb-2">Thank you for trusting Rayan Info Solutions.</p>
        <p className="mb-0">We take your privacy seriously and are committed to transparency and protection.</p>
      </div>
    </div>
  );
}
